<div class="coworking-stepper-container">
  <div *ngFor="let step of steps" class="step-container">
    <span class="step" [ngClass]="step.isActive ? 'active' : 'disabled'">
      {{ step.stepNumber }}
    </span>
    <div class="title" [ngClass]="step.isActive ? 'active' : 'disabled'">
      {{ step.title | translate }}
    </div>
  </div>
</div>